import clsx from "clsx";
import Logo from "components/Reusable/Logo";
import AuthTitle from "../AuthTitle";
import LoginForm from "../LoginForm";
import ThirdPartyAuth from "../ThirdPartyAuth";

import { memo } from "react";
import type { AuthenticationOptionsT } from "models/models";

import styles from "./signIn.module.scss";

interface SignInI extends React.HTMLAttributes<HTMLDivElement> {
  subUserAuthOptions: AuthenticationOptionsT;
  onSubmitSuccess?: (...args: unknown[]) => void;
  onSubUserSubmitSuccess?: (...args: unknown[]) => void;
}

const SignIn = memo((props: SignInI) => {
  const { className, onSubmitSuccess, onSubUserSubmitSuccess, ...restProps } =
    props;

  return (
    <div className={clsx(styles.wrapper, className)} {...restProps}>
      <Logo color="gray" />
      <AuthTitle type="sign-in" />
      <LoginForm
        onSubmitSuccess={onSubmitSuccess}
        onSubUserSubmitSuccess={onSubUserSubmitSuccess}
      />
      <ThirdPartyAuth />
    </div>
  );
});

export default SignIn;
